import { cloneDeep } from 'lodash';

export const QUOTE = {
  vehicle: {},
  drivers: [{}],
  cover: {},
};

export const getQuotePayload = config => {
  const payload = cloneDeep(QUOTE);
  payload.cover.userKeepSignIn = process.env.NODE_ENV === 'production' ? config.partnerSignin : !!process.env.VUE_APP_PARTNER_SIGNIN;

  return payload;
};
